import { t } from "ttag";

import { Unauthorized } from "metabase/common/components/ErrorPages";
import { usePageTitle } from "metabase/hooks/use-page-title";

/**
 * Route-level wrapper for `/unauthorized`. Sets the title here, on the
 * wrapper, rather than in the shared `Unauthorized` component itself, since
 * that component is also reused inline in non-page contexts (e.g. a single
 * forbidden card within an otherwise-titled page) where it shouldn't own
 * the page title.
 */
export const UnauthorizedPage = () => {
  usePageTitle(t`Sorry, you don't have permission to see that`);

  return <Unauthorized />;
};
